import {yupResolver} from '@hookform/resolvers/yup'
import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useForm} from 'react-hook-form'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {Select} from '../../../../../../components/UI/Select'
import {getSnackBar, getSnackBarToast} from '../../../../../../util/snackBar'
import {newFurnitureModalSchema} from '../../../../../../util/validationHoteleria'
import {useCentralServices} from '../../../../hooks/useCentralServices'
import {FurnitureModel} from '../../../furniture/models'
import {editFurnitureService} from '../../../furniture/services/editFurniture.service'
import {getFurnitureByIdService} from '../../../furniture/services/getFurnitureById.service'
import {MasterModel} from '../../models'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  furnitureToEdit: FurnitureModel
  getFurnitures: () => void
}

const ModalUpdateFurniture: FC<Props> = ({show, setShow, furnitureToEdit, getFurnitures}) => {
  const handleClose = () => {
    setShow(false)
  }
  const [furnitureTypes, setFurnitureTypes] = useState<MasterModel[] | any>([])
  const {getMasterTable} = useCentralServices()

  const {
    register,
    setValue,
    handleSubmit,
    // watch,
    control,
    formState: {errors},
  } = useForm<FurnitureModel>({
    resolver: yupResolver(newFurnitureModalSchema),
  })

  const onSubmit = async (data: FurnitureModel) => {
    const {data: res} = await editFurnitureService(data)
    if (!res.error) {
      getSnackBarToast('Se actualizó con exito', 'success')
      handleClose()
      getFurnitures()
      //mostrar snackbar
    } else {
      getSnackBarToast(res.message, 'error')
    }
  }

  useEffect(() => {
    getFurnitureData()
    getFurnitureTypesFn()
  }, [])

  const getFurnitureData = async () => {
    try {
      const {
        data: {data},
      } = await getFurnitureByIdService(furnitureToEdit.Id)
      const {Codigo, ModuloId, Observaciones, Descripcion, TipoMobiliarioId, Id} = data
      setValue('Id', Id)
      // setValue('HabitacionId', currentTabItem.idToEdit as any)
      setValue('ModuloId', ModuloId)
      setValue('TipoMobiliarioId', TipoMobiliarioId)
      setValue('Codigo', Codigo)
      setValue('Observaciones', Observaciones)
      setValue('Descripcion', Descripcion)
    } catch (error) {
      console.log(error)
    }
  }

  const getFurnitureTypesFn = async () => {
    const data = await getMasterTable('TipoMobiliario', true)
    setFurnitureTypes(data)
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-xl'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Editar Mobiliario</h5>

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className='p-6'>
              <div className='row'>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Tipo de Mobiliario</label>
                  <Select
                    control={control}
                    name='TipoMobiliarioId'
                    data={furnitureTypes}
                    errors={errors}
                  />
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Descripción de Mobiliario</label>
                  <div className='sdx_form_input'>
                    <input
                      type='text'
                      className='form-control sdx-centra-input-form'
                      {...register('Descripcion')}
                    />
                    <p>{errors.Descripcion?.message}</p>
                  </div>
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Código de Mobiliario</label>
                  <div className='sdx_form_input'>
                    <input
                      type='text'
                      className='form-control sdx-centra-input-form'
                      {...register('Codigo')}
                    />
                    <p>{errors.Codigo?.message}</p>
                  </div>
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Observaciones</label>
                  <div className='sdx_form_input'>
                    <input
                      type='text'
                      className='form-control sdx-centra-input-form'
                      {...register('Observaciones')}
                    />
                    <p>{errors.Observaciones?.message}</p>
                  </div>
                </div>
              </div>
            </div>
            {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
            <div className='d-flex justify-content-center mb-3'>
              <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                Cancelar
              </button>
              <button type='button' className='btn btn-primary' onClick={handleSubmit(onSubmit)}>
                Guardar
              </button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}

export {ModalUpdateFurniture}
